





















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Checkbox, CheckboxGroup, Button, Field, Popup, Area } from "vant";
import CustomUploader from "./components/CustomUploader.vue";
import qs from "qs";

const createAccountModule = namespace("createAccount");
const failReasonModule = namespace("failReason");

@Component({
  name: 'AddressProof',
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
    customUploader: CustomUploader
  }
})
export default class AddressProof extends Vue {
  @createAccountModule.Getter("address_proof_info") address_proof_info: any;
  @createAccountModule.Mutation("SAVE_W8BEN_INFO") saveW8benInfo: any;
  @failReasonModule.Mutation("SAVE_MODIFIED_FAIL_REASON")
  saveModifiedFailReason: any;

  addressProofImgObj = {};
  addressCode = "";
  form = {
    address_img: "",
    province_name: "",
    province_code: "",
    city_name: "",
    city_code: "",
    country_name: "",
    country_code: "",
    detail_address: ""
  };

  areaList = {};
  enAreaList = {
    province_list: {},
    city_list: {},
    county_list: {}
  };
  showAddressPicker = false;
  isLoadingAddress = true;

  get isSubmitDisabled() {
    return !(
      this.addressText &&
      this.form.address_img &&
      this.form.detail_address
    );
  }

  get addressText() {
    if (this.form.province_name) {
      return (
        this.form.province_name + this.form.city_name + this.form.country_name
      );
    } else {
      return "";
    }
  }

  @Watch("addressProofImgObj", { deep: true })
  watchAddressProofImgObj(value) {
    this.form.address_img = value.content;
  }

  @Watch("address_proof_info", { deep: true, immediate: true })
  watchAddressProofInfo(val) {
    const { modify } = this.$route.query;
    if (!modify) return;
    const { address_img, address } = val;
    this.form = {
      ...this.form,
      ...address
    };
    this.addressProofImgObj = address_img;
  }

  handleOpenAddressPicker() {
    if (Object.keys(this.areaList).length !== 0) {
      return;
    }
    //获得省市区json
    (this as any).$apis
      .getAddressLists()
      .then(res => {
        const { en, zh } = res;
        this.areaList = zh;
        this.enAreaList = en;
        this.isLoadingAddress = false;
      })
      .catch(e => {
        
      });
  }

  handleSetAddress(arr) {
    this.form.province_name = arr[0] ? arr[0].name : "";
    this.form.province_code = arr[0] ? arr[0].code : "";
    this.form.city_name = arr[1] ? arr[1].name : "";
    this.form.city_code = arr[1] ? arr[1].code : "";
    this.form.country_name = arr[2] ? arr[2].name : "";
    this.form.country_code = arr[2] ? arr[2].code : "";
    this.showAddressPicker = false;
  }

  translateAddressData(address) {
    const { province_code, city_code, country_code } = address;
    const { province_list, city_list, county_list } = this.enAreaList;
    const province_name = province_list[province_code];
    const city_name = city_list[city_code];
    const country_name = county_list[country_code];
    return {
      province_name,
      province_code,
      city_name,
      city_code,
      country_name,
      country_code
    };
  }

  handleSaveAddressProof() {

    (this as any).$apis
      .saveAddressProof(this.form)
      .then(() => {
        if (this.$route.query.modify == "1") {
          this.saveModifiedFailReason(3);
          this.$router.go(-1);
        } else {
          const address = this.translateAddressData(this.form);
          this.saveW8benInfo({ ...address });
          // 大陆 or 香港
          const { open_status } = this.$route.query;
          if (open_status == "2") {
            this.$router.push({
              path: "/face-record",
              query: this.$route.query
            });
          } else {
            this.postFaceInfo();
          }
          // this.$router.push("/face-record");
        }
      })
      .catch(e => {
        
      });
  }
  postFaceInfo() {
    let id_card_ocr_info: any = localStorage.getItem("id_card_ocr_info");
    id_card_ocr_info = id_card_ocr_info ? JSON.parse(id_card_ocr_info) : {};
    const callBackUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      "/face-result";
    (this as any).$apis
      .postFaceInfo({
        // 身份证信息 缓存获取一下
        card_no: id_card_ocr_info.id_card,
        name: id_card_ocr_info.real_name,
        redirectUrl: encodeURI(callBackUrl)
      })
      .then(res => {
        window.location.href = res.h5Url;
      })
      .catch(e => {
        
      });
  }
}
